import { z } from 'zod';

// The bell: things that happened while you were busy, newest first. Each one says what happened and where
// tapping it goes. Kept 30 days.
export const NOTICE_KEEP_DAYS = 30;
// money: someone sent you money, asked you for some, paid what you asked, or the team's check sent a transfer back
export const NoticeKind = z.enum([
  'message_request',
  'money_received',
  'money_asked',
  'money_paid',
  'money_returned',
  'meal_received',
  'visit_invite',
  'visit_knock',
  'visit_answer',
  'advert_live',
  'advert_rejected',
  'advert_removed',
  'business_shut',
  'business_staff_left',
  // a flight lost a bag (covered or not)
  'bag_lost',
  // a friend saved you a seat on their flight
  'flight_seat',
  // Rail Co.: the week's bills, a crew walking off, a train worn out or broken down
  'rail_bills',
  'rail_crew_left',
  'rail_worn',
  'rail_breakdown',
  // Health: falling ill, getting worse, taken to hospital, getting better by yourself
  'health_sick',
  'health_worse',
  'health_hospital',
  'health_better',
  // Staff: wages paid, or someone had to go (unpaid, or the home no longer fits)
  'staff_paid',
  'staff_left',
  // People and Family: asked to be partners or family, said yes, ended; a date, proposal or wedding asked,
  // answered, or a partnership ended by a wedding
  'tie_asked',
  'tie_answered',
  'tie_ended',
  'family_asked',
  'family_answered',
  'family_married',
  // a baby arrived or an adopted child came home; a child's new name
  'family_child',
  'family_renamed',
  // Hustle: applied, hired, an offer, answered, done, sent back, paid, called off or given up
  'hustle_update',
  // Gist: a post or comment the team took down after reports
  'gist_update',
  // Gov: elected Mayor, or the Mayor's announcement taken down
  'gov_update',
]);
export type NoticeKind = z.infer<typeof NoticeKind>;

export const NoticeView = z.object({
  id: z.string().uuid(),
  kind: NoticeKind,
  title: z.string(),
  body: z.string(),
  // where it leads: a chat with someone
  link: z.object({ kind: z.literal('direct'), lifeId: z.string().uuid() }).nullable(),
  createdAt: z.string(),
  read: z.boolean(),
});
export type NoticeView = z.infer<typeof NoticeView>;
export const NoticesReply = z.object({ notices: z.array(NoticeView), unread: z.number().int() });
export type NoticesReply = z.infer<typeof NoticesReply>;
